import { render, staticRenderFns } from "./PostingShell.vue?vue&type=template&id=5b2d1964"
import script from "./PostingShell.vue?vue&type=script&lang=js"
export * from "./PostingShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports